"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const sdk_1 = require("./@uniswap/sdk");
const erc20_json_1 = __importDefault(require("./abis/erc20.json"));
const utils_1 = require("./utils");
const abi_1 = require("@ethersproject/abi");
const ERC20_INTERFACE = new abi_1.Interface(erc20_json_1.default);
class SwapBalance {
    constructor(swapMulticall) {
        // get the balance for a single token/account combo
        this.useTokenBalance = async (account, token) => {
            const tokenBalances = await this.useTokenBalances(account, [token]);
            if (!token)
                return undefined;
            return tokenBalances[token.address];
        };
        this.useCurrencyBalances = async (account, currencies) => {
            var _a, _b, _c;
            const tokens = (_a = currencies === null || currencies === void 0 ? void 0 : currencies.filter((currency) => currency instanceof sdk_1.Token)) !== null && _a !== void 0 ? _a : [];
            const tokenBalances = await this.useTokenBalances(account, tokens);
            const containsETH = (_b = currencies === null || currencies === void 0 ? void 0 : currencies.some((currency) => currency === sdk_1.ETHER)) !== null && _b !== void 0 ? _b : false;
            const ethBalance = await this.useETHBalances(containsETH ? [account] : []);
            return ((_c = currencies === null || currencies === void 0 ? void 0 : currencies.map((currency) => {
                if (!account || !currency)
                    return undefined;
                if (currency instanceof sdk_1.Token)
                    return tokenBalances[currency.address];
                if (currency === sdk_1.ETHER)
                    return ethBalance[account];
                return undefined;
            })) !== null && _c !== void 0 ? _c : []);
        };
        this.swapMulticall = swapMulticall;
    }
    /**
     * Returns a map of the given addresses to their eventually consistent ETH balances.
     */
    async useETHBalances(uncheckedAddresses) {
        const multicallContract = this.swapMulticall.swapContract.useMulticallContract();
        const addresses = uncheckedAddresses
            ? uncheckedAddresses
                .map(utils_1.isAddress)
                .filter((a) => a !== false)
                .sort()
            : [];
        const results = await this.swapMulticall.useSingleContractMultipleData(multicallContract, "getEthBalance", addresses.map((address) => [address]));
        return addresses.reduce((memo, address, i) => {
            var _a, _b;
            const value = (_b = (_a = results === null || results === void 0 ? void 0 : results[i]) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b[0];
            if (value)
                memo[address] = sdk_1.CurrencyAmount.ether(sdk_1.JSBI.BigInt(value.toString()));
            return memo;
        }, {});
    }
    /**
     * Returns a map of token addresses to their eventually consistent token balances for a single account.
     */
    async useTokenBalancesWithLoadingIndicator(address, tokens) {
        var _a;
        const validatedTokens = (_a = tokens === null || tokens === void 0 ? void 0 : tokens.filter((t) => (0, utils_1.isAddress)(t === null || t === void 0 ? void 0 : t.address) !== false)) !== null && _a !== void 0 ? _a : [];
        const validatedTokenAddresses = validatedTokens.map((vt) => vt.address);
        const balances = await this.swapMulticall.useMultipleContractSingleData(validatedTokenAddresses, ERC20_INTERFACE, "balanceOf", [address]);
        // @ts-ignore
        const anyLoading = balances.some((callState) => callState.loading);
        return [
            address && validatedTokens.length > 0
                ? validatedTokens.reduce((memo, token, i) => {
                    var _a, _b;
                    const value = (_b = (_a = balances === null || balances === void 0 ? void 0 : balances[i]) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b[0];
                    const amount = value ? sdk_1.JSBI.BigInt(value.toString()) : undefined;
                    if (amount) {
                        memo[token.address] = new sdk_1.TokenAmount(token, amount);
                    }
                    return memo;
                }, {})
                : {},
            anyLoading
        ];
    }
    async useTokenBalances(address, tokens) {
        const data = await this.useTokenBalancesWithLoadingIndicator(address, tokens);
        return data[0];
    }
    async useCurrencyBalance(account, currency) {
        const results = await this.useCurrencyBalances(account, [currency]);
        return results[0];
    }
}
exports.default = SwapBalance;
